import { ChallengeRow, ChallengeRowLarge, FeatureTag, NavCardMedium, NavCardSmall, NavSection } from "@Components/game";
import HeroBackground from "@Components/game/hero/hero-background";
import ContainerWrapper from "@Components/generic/container-wrapper";
import { Events } from "@Context/common/general/context";
import { faFlagPennant, faInfoCircle, faStar } from "@fortawesome/pro-solid-svg-icons";
import useDemoAccount from "@hooks/common/user/use-demo-account";
import { useGlobalContext } from "@hooks/index";
import useI18n from "@i18n";
import { Stack, useTheme } from "@mui/material";
import { useEffect } from "react";

const Home = () => {
  const { globalState } = useGlobalContext();
  const { i18n } = useI18n();
  const theme = useTheme();
  const { isDemo } = useDemoAccount();
  const inBootcamp = globalState.user.inBootcamp && !isDemo;

  useEffect(() => {
    Events.app.hideHeaderButton.emit();
  }, []);

  return (
    <ContainerWrapper id="HOME" fullHeight>
      <HeroBackground />

      <Stack spacing={6}>
        <Stack spacing={8} sx={{ padding: theme.spacing(inBootcamp ? 14 : 25, 0, 0) }}>
          {inBootcamp && (
            <NavSection title="Bootcamp" icon={faStar} sx={{ position: "relative", "> *:first-child": { padding: theme.spacing(0, 6) } }}>
              <ChallengeRowLarge tag="BOOTCAMP" padding={theme.spacing(6)} />
            </NavSection>
          )}

          <Stack direction="row" spacing={3} sx={{ padding: theme.spacing(0, 6) }}>
            <NavCardMedium
              title={i18n("home.navigation.career.title")}
              subtitle={i18n("home.navigation.career.subtitle")}
              imgSrc="https://challenge-thumbs.b-cdn.net/byb-mode-posters/img-career-thumb.webp"
              to="/home/career"
              disabled={inBootcamp || isDemo}
            />
            <NavCardMedium
              title={i18n("home.navigation.challenges.title")}
              subtitle={i18n("home.navigation.challenges.subtitle")}
              imgSrc="https://challenge-thumbs.b-cdn.net/byb-mode-posters/img-challenges-thumb.webp"
              to="/challenges"
              disabled={inBootcamp}
            />
            <NavCardMedium
              title={i18n("home.navigation.practice.title")}
              subtitle={i18n("home.navigation.practice.subtitle")}
              imgSrc="https://challenge-thumbs.b-cdn.net/byb-mode-posters/img-practice-thumb.webp"
              to="/home/practise"
              disabled={inBootcamp || isDemo}
            />
            <NavCardMedium
              title={i18n("home.navigation.matchplay.title")}
              subtitle={i18n("home.navigation.matchplay.subtitle")}
              imgSrc="https://challenge-thumbs.b-cdn.net/byb-mode-posters/img-matchplay-thumb.webp"
              to="/home/matchplay"
              disabled={inBootcamp || isDemo}
            >
              <FeatureTag text={i18n("common.beta")} />
            </NavCardMedium>
          </Stack>
        </Stack>

        {!inBootcamp && !isDemo && (
          <NavSection title={i18n("home.section.latest-challenges.title")} icon={faFlagPennant} headerSx={{ padding: theme.spacing(0, 6) }}>
            <ChallengeRow
              limit={3}
              overflow={false}
              orderBy={[
                {
                  field: "created_at",
                  direction: "desc",
                },
              ]}
              filters={{ max_rating: globalState.user.userRating! }}
            />
          </NavSection>
        )}

        <Stack direction="row" spacing={3} sx={{ padding: theme.spacing(0, 6, 12) }}>
          <NavCardSmall title={i18n("home.navigation.guides.title")} color="green" icon={faInfoCircle} to="/home/guides" />
        </Stack>
      </Stack>
    </ContainerWrapper>
  );
};

export default Home;
